<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <div>
            <div class="flex gap-x-2 items-center">
                <button
                    type="button"
                    @click="toggle"
                    :class="active ? 'bg-indigo-600' : 'bg-gray-200'"
                    class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    role="switch"
                    aria-checked="false"
                >
                    <span class="sr-only">{{ $t('messages.active') }}</span>
                    <span
                        :class="active ? 'translate-x-5' : 'translate-x-0'"
                        aria-hidden="true"
                        class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200"
                    ></span>
                </button>
                <AppButton desired-action v-if="isLoading">
                    <span v-if="isLoading" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
            <div>
                <div v-if="active">
                    <div v-if="closedAt">{{ $t('messages.active_until_date', { date: closedAt }) }}</div>
                </div>
                <div>{{ $t('messages.students_confirmed_attendance_today', { count: count }) }}</div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';

export default {
    name: 'SelfAttendanceWidget',
    components: {
        BaseWidget,
    },
};
</script>
<script setup>
import { ref, watch } from 'vue';
import { useAxios } from '@vueuse/integrations/useAxios';
import AppButton from '@/components/AppButton.vue';
const props = defineProps({
    widget: {
        required: true,
        type: Object,
    },
});

const active = ref(props.widget.content.active);
const closedAt = ref(props.widget.content.closed_at_date);
const count = ref(props.widget.content.count);
const { execute, isLoading, data } = useAxios(props.widget.content.url, { method: 'PATCH' }, { immediate: false });
watch(data, (newVal) => {
    active.value = newVal.active;
    closedAt.value = newVal.closed_at_date;
});
function toggle() {
    execute();
}
</script>
